<ng-container *transloco="let t">
  <div class="flex w-[50rem] flex-col gap-4">
    <IInput
      [placeholder]="t('product-group-creation.give_product_group_name')"
      [value]="pgName ?? ''"
      (valueChange)="pgName = $event"
      [maxLength]="80"
      [label]="t('common.name')"
    />

    <div class="flex justify-end gap-x-2">
      <IButton label="{{ t('common.cancel') }}" color="gray" variant="ghost" (onClick)="modalRef.close()" />
      <IButton label="{{ t('common.next') }}" (onClick)="create()" />
    </div>
  </div>
</ng-container>
